// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/movementsensor/v1/movementsensor.proto" (package "viam.component.movementsensor.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetReadingsResponse } from "../../../common/v1/common";
import { GetReadingsRequest } from "../../../common/v1/common";
import { GetGeometriesResponse } from "../../../common/v1/common";
import { GetGeometriesRequest } from "../../../common/v1/common";
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { GeoPoint } from "../../../common/v1/common";
import { Orientation } from "../../../common/v1/common";
import { Vector3 } from "../../../common/v1/common";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetLinearVelocityRequest
 */
export interface GetLinearVelocityRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetLinearVelocityResponse
 */
export interface GetLinearVelocityResponse {
    /**
     * Linear velocity in m/s across x/y/z axes
     *
     * @generated from protobuf field: viam.common.v1.Vector3 linear_velocity = 1;
     */
    linearVelocity?: Vector3;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetAngularVelocityRequest
 */
export interface GetAngularVelocityRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetAngularVelocityResponse
 */
export interface GetAngularVelocityResponse {
    /**
     * Angular velocity in degrees/s across x/y/z axes
     *
     * @generated from protobuf field: viam.common.v1.Vector3 angular_velocity = 1;
     */
    angularVelocity?: Vector3;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetCompassHeadingRequest
 */
export interface GetCompassHeadingRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetCompassHeadingResponse
 */
export interface GetCompassHeadingResponse {
    /**
     * A number from 0-359 in degrees where
     * 0 is North, 90 is East, 180 is South, and 270 is   West
     *
     * @generated from protobuf field: double value = 1;
     */
    value: number;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetOrientationRequest
 */
export interface GetOrientationRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetOrientationResponse
 */
export interface GetOrientationResponse {
    /**
     * Orientation is returned as an orientation message with
     * OX OY OZ as unit-normalized components of the axis of the vector, and Theta in degrees
     *
     * @generated from protobuf field: viam.common.v1.Orientation orientation = 1;
     */
    orientation?: Orientation;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetPositionRequest
 */
export interface GetPositionRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetPositionResponse
 */
export interface GetPositionResponse {
    /**
     * Position is returned in a coordinate of latitute and longitude
     * and an altidue in meters
     *
     * @generated from protobuf field: viam.common.v1.GeoPoint coordinate = 1;
     */
    coordinate?: GeoPoint;
    /**
     * @generated from protobuf field: float altitude_m = 2;
     */
    altitudeM: number;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetPropertiesRequest
 */
export interface GetPropertiesRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetPropertiesResponse
 */
export interface GetPropertiesResponse {
    /**
     * @generated from protobuf field: bool linear_velocity_supported = 1;
     */
    linearVelocitySupported: boolean;
    /**
     * @generated from protobuf field: bool angular_velocity_supported = 2;
     */
    angularVelocitySupported: boolean;
    /**
     * @generated from protobuf field: bool orientation_supported = 3;
     */
    orientationSupported: boolean;
    /**
     * @generated from protobuf field: bool position_supported = 4;
     */
    positionSupported: boolean;
    /**
     * @generated from protobuf field: bool compass_heading_supported = 5;
     */
    compassHeadingSupported: boolean;
    /**
     * @generated from protobuf field: bool linear_acceleration_supported = 6;
     */
    linearAccelerationSupported: boolean;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetAccuracyRequest
 */
export interface GetAccuracyRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetAccuracyResponse
 */
export interface GetAccuracyResponse {
    /**
     * @generated from protobuf field: map<string, float> accuracy = 1;
     */
    accuracy: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: optional float position_hdop = 2;
     */
    positionHdop?: number;
    /**
     * @generated from protobuf field: optional float position_vdop = 3;
     */
    positionVdop?: number;
    /**
     * @generated from protobuf field: optional int32 position_nmea_gga_fix = 4;
     */
    positionNmeaGgaFix?: number;
    /**
     * @generated from protobuf field: optional float compass_degrees_error = 5;
     */
    compassDegreesError?: number;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetLinearAccelerationRequest
 */
export interface GetLinearAccelerationRequest {
    /**
     * Name of a movement sensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.movementsensor.v1.GetLinearAccelerationResponse
 */
export interface GetLinearAccelerationResponse {
    /**
     * Linear acceleration in m/s across x/y/z axes
     *
     * @generated from protobuf field: viam.common.v1.Vector3 linear_acceleration = 1;
     */
    linearAcceleration?: Vector3;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetLinearVelocityRequest$Type extends MessageType<GetLinearVelocityRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetLinearVelocityRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetLinearVelocityRequest
 */
export const GetLinearVelocityRequest = new GetLinearVelocityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLinearVelocityResponse$Type extends MessageType<GetLinearVelocityResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetLinearVelocityResponse", [
            { no: 1, name: "linear_velocity", kind: "message", T: () => Vector3 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetLinearVelocityResponse
 */
export const GetLinearVelocityResponse = new GetLinearVelocityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAngularVelocityRequest$Type extends MessageType<GetAngularVelocityRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetAngularVelocityRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetAngularVelocityRequest
 */
export const GetAngularVelocityRequest = new GetAngularVelocityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAngularVelocityResponse$Type extends MessageType<GetAngularVelocityResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetAngularVelocityResponse", [
            { no: 1, name: "angular_velocity", kind: "message", T: () => Vector3 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetAngularVelocityResponse
 */
export const GetAngularVelocityResponse = new GetAngularVelocityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompassHeadingRequest$Type extends MessageType<GetCompassHeadingRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetCompassHeadingRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetCompassHeadingRequest
 */
export const GetCompassHeadingRequest = new GetCompassHeadingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompassHeadingResponse$Type extends MessageType<GetCompassHeadingResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetCompassHeadingResponse", [
            { no: 1, name: "value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetCompassHeadingResponse
 */
export const GetCompassHeadingResponse = new GetCompassHeadingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrientationRequest$Type extends MessageType<GetOrientationRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetOrientationRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetOrientationRequest
 */
export const GetOrientationRequest = new GetOrientationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrientationResponse$Type extends MessageType<GetOrientationResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetOrientationResponse", [
            { no: 1, name: "orientation", kind: "message", T: () => Orientation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetOrientationResponse
 */
export const GetOrientationResponse = new GetOrientationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionRequest$Type extends MessageType<GetPositionRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetPositionRequest
 */
export const GetPositionRequest = new GetPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionResponse$Type extends MessageType<GetPositionResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetPositionResponse", [
            { no: 1, name: "coordinate", kind: "message", T: () => GeoPoint },
            { no: 2, name: "altitude_m", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetPositionResponse
 */
export const GetPositionResponse = new GetPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesRequest$Type extends MessageType<GetPropertiesRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetPropertiesRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetPropertiesRequest
 */
export const GetPropertiesRequest = new GetPropertiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesResponse$Type extends MessageType<GetPropertiesResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetPropertiesResponse", [
            { no: 1, name: "linear_velocity_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "angular_velocity_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "orientation_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "position_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "compass_heading_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "linear_acceleration_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetPropertiesResponse
 */
export const GetPropertiesResponse = new GetPropertiesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccuracyRequest$Type extends MessageType<GetAccuracyRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetAccuracyRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetAccuracyRequest
 */
export const GetAccuracyRequest = new GetAccuracyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccuracyResponse$Type extends MessageType<GetAccuracyResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetAccuracyResponse", [
            { no: 1, name: "accuracy", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 2 /*ScalarType.FLOAT*/ } },
            { no: 2, name: "position_hdop", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "position_vdop", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "position_nmea_gga_fix", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "compass_degrees_error", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetAccuracyResponse
 */
export const GetAccuracyResponse = new GetAccuracyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLinearAccelerationRequest$Type extends MessageType<GetLinearAccelerationRequest> {
    constructor() {
        super("viam.component.movementsensor.v1.GetLinearAccelerationRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetLinearAccelerationRequest
 */
export const GetLinearAccelerationRequest = new GetLinearAccelerationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLinearAccelerationResponse$Type extends MessageType<GetLinearAccelerationResponse> {
    constructor() {
        super("viam.component.movementsensor.v1.GetLinearAccelerationResponse", [
            { no: 1, name: "linear_acceleration", kind: "message", T: () => Vector3 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.movementsensor.v1.GetLinearAccelerationResponse
 */
export const GetLinearAccelerationResponse = new GetLinearAccelerationResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.movementsensor.v1.MovementSensorService
 */
export const MovementSensorService = new ServiceType("viam.component.movementsensor.v1.MovementSensorService", [
    { name: "GetLinearVelocity", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/linear_velocity" } }, I: GetLinearVelocityRequest, O: GetLinearVelocityResponse },
    { name: "GetAngularVelocity", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/angular_velocity" } }, I: GetAngularVelocityRequest, O: GetAngularVelocityResponse },
    { name: "GetCompassHeading", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/compass_heading" } }, I: GetCompassHeadingRequest, O: GetCompassHeadingResponse },
    { name: "GetOrientation", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/orientation" } }, I: GetOrientationRequest, O: GetOrientationResponse },
    { name: "GetPosition", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/position" } }, I: GetPositionRequest, O: GetPositionResponse },
    { name: "GetProperties", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/properties" } }, I: GetPropertiesRequest, O: GetPropertiesResponse },
    { name: "GetAccuracy", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/accuracy" } }, I: GetAccuracyRequest, O: GetAccuracyResponse },
    { name: "GetLinearAcceleration", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/linear_acceleration" } }, I: GetLinearAccelerationRequest, O: GetLinearAccelerationResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/movementsensor/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse },
    { name: "GetGeometries", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/geometries" } }, I: GetGeometriesRequest, O: GetGeometriesResponse },
    { name: "GetReadings", options: { "google.api.http": { get: "/viam/api/v1/component/movementsensor/{name}/readings" } }, I: GetReadingsRequest, O: GetReadingsResponse }
]);
